import { render, staticRenderFns } from "./CInputCurrency.vue?vue&type=template&id=64b860aa&"
import script from "./CInputCurrency.vue?vue&type=script&lang=js&"
export * from "./CInputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports